import React, { PropsWithChildren } from 'react';

import { Grid, IconLogoResponsive, IconLogoTextResponsive, LogoAnchor } from './elements';

export const SimpleNav: React.FC<PropsWithChildren> = () => (
  <Grid container xs={12} justifyContent="center" alignItems="center">
    <LogoAnchor to="/" marginRight>
      <IconLogoResponsive />
    </LogoAnchor>
    <LogoAnchor to="/">
      <IconLogoTextResponsive />
    </LogoAnchor>
  </Grid>
);
